<style>
	.name-box {
		overflow-x: hidden;
		margin: auto;
		padding: 1em;
		width: 20em;
		height: 10em;
		border-radius: 10px;
		background: #d5e0ff;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
	}

	.input-container {
		font-family: Arial, Helvetica, sans-serif;
		font-size: large;
		margin: auto;
		padding: 5px;
		height: 90%;
		width: 90%;

		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.input-container>input {
		text-align: center;
		height: 2em;
		padding-left: 1em;
		padding-right: 1em;
		width: 80%;
		font-size: 12pt;
	}

	.btn {
		color: white;
		background-color: #f24b4b;
		height: 2em;
		text-align: center;
		border-radius: 3px;

		width: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.btn>span {
		font-family: Arial, Helvetica, sans-serif;
		letter-spacing: 1px;
	}

	.username-label {
		text-align: center;
	}
	.err-label {
		text-align: center;
		color: red;
		font-size: 11pt;
	}
</style>

<script>
	export let nextPart
	export let uName
	let lengthErr = false

	function checkUsername() {
		if (uName.length > 3 && uName.length < 10) {
			nextPart()
		} else {
			lengthErr = true
		}
	}
</script>

<div class="name-box">
	<div class="input-container">
		<span class="username-label">Enter your Username</span>
		{#if lengthErr}
			<span class="err-label">Username must be at least 3 characters</span>
		{/if}
		<input bind:value={uName} type="text">

		<div class="btn" on:click={checkUsername}>
			<span>></span>
		</div>
	</div>
</div>